import { useState } from "react";
import { ChevronDown, ChevronUp, MapPin } from "lucide-react";
import PackageOptionCard from "@/components/cards/PackageOptionCard";
import { SourcePill, HeaderAccessory } from "@/components/cards/_pills";

export default function PackageGroupCard({ card, onPlacesToSee }) {
    const {
        title,
        vibe,
        options = [],
        live,
        source,
        source_label,
        destination_weather,
    } = card;
    const [expanded, setExpanded] = useState(false);
    const visible = expanded ? options : options.slice(0, 4);
    const hiddenCount = Math.max(options.length - 4, 0);
    const destCity = (options[0]?.destination || "").split(",")[0].trim();
    const days = options[0]?.duration_nights || options[0]?.duration_days || 3;

    return (
        <section className="space-y-3" data-testid={`package-group-${vibe}`}>
            <div className="flex flex-wrap items-center justify-between gap-2 px-1">
                <div className="flex items-center gap-2">
                    <h2 className="text-[18px] font-semibold tracking-tight text-[#0A0A0A]">
                        {title}
                    </h2>
                    {live && (
                        <SourcePill
                            source={source || "web_search"}
                            source_label={source_label || "Web"}
                        />
                    )}
                </div>
                <div className="flex items-center gap-3">
                    {destCity && onPlacesToSee && (
                        <button
                            type="button"
                            onClick={() =>
                                onPlacesToSee(`things to do in ${destCity} for ${days} days`)
                            }
                            data-testid={`places-to-see-${vibe}`}
                            className="inline-flex items-center gap-1.5 rounded-full border border-[#E5E5E5] bg-white px-3 py-1 text-[11.5px] font-medium text-[#0A0A0A] transition hover:border-[#F97316] hover:text-[#F97316]"
                        >
                            <MapPin size={11} strokeWidth={2} />
                            Places to see in {destCity}
                        </button>
                    )}
                    <HeaderAccessory
                        destinationWeather={destination_weather}
                        dotColor="#7C3AED"
                    />
                </div>
            </div>
            <div className="-mx-1 overflow-x-auto pb-2">
                <div className="flex gap-3 px-1">
                    {visible.map((p) => (
                        <PackageOptionCard key={p.id} packet={p} />
                    ))}
                </div>
            </div>
            {hiddenCount > 0 && (
                <button
                    type="button"
                    onClick={() => setExpanded((v) => !v)}
                    data-testid={`package-toggle-${vibe}`}
                    className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-[13px] font-medium text-[#0A0A0A] transition hover:bg-[#F5F5F5]"
                >
                    {expanded ? (
                        <>
                            <ChevronUp size={14} strokeWidth={2.25} /> Hide extras
                        </>
                    ) : (
                        <>
                            <ChevronDown size={14} strokeWidth={2.25} /> More options (+{hiddenCount})
                        </>
                    )}
                </button>
            )}
        </section>
    );
}
